export default "__VITE_ASSET__ZnD1Cspn__"